import { isPrivateChatRoom } from '@dinosband/bv-main-schema/dist/chat-room'
import { BvDataCenter, CHAT_ROOM_UNREAD_COUNT, LAST_MESSAGE_ID, SubscriptionManager } from '@dinosband/bv-data-center'
import settings from '@dinosband/bv-settings'
import { _last } from '@dinosband/dbi-utils'

import { MessengerContext, ChatRoomStore, ChatRoomControllerPool } from '../..'


export class UnreadCountsController {

  dataCenter: BvDataCenter
  context: MessengerContext
  controllerPool: ChatRoomControllerPool

  private subscriptions = new SubscriptionManager()

  constructor (context: MessengerContext, dataCenter: BvDataCenter, controllerPool: ChatRoomControllerPool) {
    this.context = context
    this.dataCenter = dataCenter
    this.controllerPool = controllerPool
    this.initSubscribe()
  }

  init () {
    const chatRoomIds = this.dataCenter.privateChatRooms.map((i) => i.id)
    this.initSettings(chatRoomIds)
  }

  cleanup () {
    // this.subscriptions.cleanup()
  }

  private get vuex () {
    return this.context.vuexStore
  }

  private initSubscribe () {
    this.subscriptions.init(this.context.pubsub)
    this.subscriptions.subscribe(CHAT_ROOM_UNREAD_COUNT, (value: ChatRoomStore) => {
      this.updateChatsUnreadCount(value)
    })
    this.subscriptions.subscribe(LAST_MESSAGE_ID, (value: number) => {
      this.updateLastMessageId(value)
    })
  }

  private initSettings (chatRoomIds: number[]) {
    const unreadCounts = settings.unreadCounts
    const registeredChatRoomIds = Object.keys(unreadCounts).map((i) => Number(i))
    const outdateds = registeredChatRoomIds.filter((i) => !chatRoomIds.includes(i))
    for (const i of outdateds) {
      delete unreadCounts[i]
    }
    settings.unreadCounts = unreadCounts
  }

  unreadPrivateMessageCount (channelId: number) {
    const chatRooms = this.dataCenter.privateChatRooms
      .filter((i) => i.channelId === channelId)
      .map((i) => this.controllerPool.chatRoomContext(i.id))
    const unreadCount = chatRooms.reduce((prev, cur) => prev + (cur.unreadCount ?? 0), 0)
    return unreadCount
  }

  unreadHelpDeskCount (channelId: number, profileId?: number) {
    let chatRooms = this.dataCenter.helpDeskChatRooms
      .filter((i) => i.channelId === channelId)
      .map((i) => this.controllerPool.chatRoomContext(i.id))
    if (profileId) {
      const selected = chatRooms.find((i) => i.participants.some((j) => j.id == profileId))
      chatRooms = selected ? [selected] : []
    }
    const unreadCount = chatRooms.reduce((prev, cur) => prev + (cur.unreadCount ?? 0), 0)
    return unreadCount
  }

  updateSettingsUnreadCount (chatRoomId: number, unreadCount: number, lastMessageId: number, lastMessageSeq: number) {
    settings.unreadCounts = {
      ...settings.unreadCounts,
      [chatRoomId]: {
        chatRoomId,
        unreadCount,
        lastMessageId,
        lastMessageSeq,
      },
    }
  }

  updateNotificationUnreadCount (count: number) {
    const mainStore = this.context.mainStore
    if (!mainStore?.user) {
      return
    }
    this.context.vuexStore.commit('chatRoomNotification/setUnreadNotifications', count)
    const lastSysNotiId = _last(mainStore.sysNotifications)?.noti.id ?? 0
    const lastReadSysNotiId = mainStore.user.lastSysNotiId ?? 0
    const lastMesgNotiId = _last(mainStore.mesgNotifications)?.noti.id ?? 0
    const lastReadMesgNotiId = mainStore.user.lastMesgNotiId ?? 0
    settings.unreadNotiCount = {
      unreadCount: count,
      lastSysNotiId,
      lastReadSysNotiId,
      lastMesgNotiId,
      lastReadMesgNotiId,
    }
  }

  updateMyPageBadge (badge: number) {
    this.vuex.commit('chatRoomNotification/setUnreadMy', badge)
  }

  updateLastMessageId (messageId: number) {
    if (this.vuex.state.chatRoomNotification.lastMessageId < messageId) {
      this.setLastMessageId(messageId)
    }
  }

  private updateChatsUnreadCount (chatRoomStore: ChatRoomStore) {
    if (isPrivateChatRoom(chatRoomStore.chatRoom.type)) {
      this.updateSettingsUnreadCount(chatRoomStore.chatRoom.id, chatRoomStore.unreadCount,
        chatRoomStore.lastMessage?.id ?? 0, chatRoomStore.lastMessage?.seq ?? 0)
    }
    const chatRoomContexts = this.dataCenter.privateChatRooms.map((i)=> this.controllerPool.chatRoomContext(i.id))
    const unreadCount = chatRoomContexts.reduce((prev, cur) => prev + (cur.unreadCount ?? 0), 0)
    this.vuex.commit('chatRoomNotification/setUnreadChats', unreadCount)
  }

  setCurrentChatRoomId (chatRoomId?: number) {
    this.vuex.commit('chatRoomNotification/setCurrentChatRoomId', chatRoomId ?? -2)
  }

  private setLastMessageId (messageId: number) {
    this.vuex.commit('chatRoomNotification/setLastMessageId', messageId)
  }

  setLastSysNotiId (messageId: number) {
    this.vuex.commit('chatRoomNotification/setLastSysNotiId', messageId)
  }


}